import {
  Component,
  ChangeDetectionStrategy,
  input,
  InputSignal,
} from '@angular/core';
import { Step } from '../../models/step/step.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent {
  /**
   * The question that is currently being displayed in the template.
   */
  public readonly step: InputSignal<Step> = input.required<Step>();
}
